import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { imgUrl, projectCategories } from "@/lib/api";

// staggered 12-col editorial recipe (cycled). mobile = single column.
// images render at their natural ratio (no cropping); stagger comes from
// column width + vertical offset only. all titles sit below the image.
const RECIPE = [
  { span: "md:col-span-7 md:col-start-1", mt: "md:mt-0" },
  { span: "md:col-span-4 md:col-start-9", mt: "md:mt-[120px]" },
  { span: "md:col-span-5 md:col-start-2", mt: "md:mt-[80px]" },
  { span: "md:col-span-5 md:col-start-8", mt: "md:mt-[40px]" },
  { span: "md:col-span-8 md:col-start-1", mt: "md:mt-[100px]" },
  { span: "md:col-span-4 md:col-start-9", mt: "md:mt-[60px]" },
];

const sentence = (s) => s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s;

function Card({ project, recipe, index }) {
  const cats = projectCategories(project);
  const services = cats.map(sentence).join(", ");

  return (
    <motion.div
      className={`col-span-12 ${recipe.span} ${recipe.mt}`}
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.8, delay: (index % 2) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    >
      <Link to={`/work/${project.slug}`} data-testid={`project-card-${project.slug}`} data-cursor-text="VIEW" className="block group">
        <div className="overflow-hidden bg-surface">
          <img
            src={imgUrl(project.cover, 1200)}
            alt={project.title}
            loading="lazy"
            decoding="async"
            className="w-full h-auto block transition-transform duration-[600ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.03]"
          />
        </div>
        <div className="mt-4">
          <h3 className="font-display uppercase font-[900] tracking-[-0.02em] leading-[0.95] text-3xl sm:text-4xl lg:text-5xl text-black">
            {project.title}
          </h3>
          {services && <p className="font-mono text-[13px] tracking-[0.04em] text-muted2 mt-3">{services}</p>}
        </div>
      </Link>
    </motion.div>
  );
}

export default function ProjectsGridEditorial({ projects }) {
  return (
    <div className="grid grid-cols-12 gap-x-4 md:gap-x-6 gap-y-16 md:gap-y-28" data-testid="projects-grid">
      {projects.map((p, i) => (
        <Card key={p.id || p.slug} project={p} recipe={RECIPE[i % RECIPE.length]} index={i} />
      ))}
    </div>
  );
}
